// Core
import { useState } from 'react';
import { useQuery } from 'react-query';

// Chakra
import {
  Text,
  useColorModeValue,
  Divider,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
} from '@chakra-ui/react';

// Services
import { apiService } from 'services/ApiService';

// Components
import NotFound from 'views/Dashboard/404.js';
import TableSkeleton from '../../../../components/TableSkeleton';
import Card from '../../../../components/Card/Card';
import FuelPricesChart from './FuelPricesChart';

const FuelPrices = () => {
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');
  const textColor = useColorModeValue('gray.700', 'white');

  const [fuelPrices, setFuelPrices] = useState([]);

  const paddingTd = '16px 0 16px 24px';

  const { isFetching } = useQuery({
    queryKey: ['fuel-prices-summary'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await apiService.getStatsFuelPrices();

      setFuelPrices(response?.data ?? []);

      return response;
    },
    retry: false,
    refetchInterval: 30000,
  });

  return (
    <>
      <FuelPricesChart />
      <Text
        fontSize="18px"
        fontStyle="normal"
        fontWeight="700"
        color={textColor}
        my="12px"
        className="page-name"
      >
        Current prices
      </Text>

      {isFetching ? (
        <TableSkeleton rowCount={9} />
      ) : fuelPrices.length > 0 ? (
        <Card padding="8px">
          <Table color={textColor}>
            <Thead>
              <Tr>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Fuel
                  </Text>
                </Td>

                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Average Price, c/L
                  </Text>
                </Td>

                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Min Price, c/L
                  </Text>
                </Td>

                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Max Price, c/L
                  </Text>
                </Td>

                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Stations
                  </Text>
                </Td>
              </Tr>
            </Thead>

            <Tbody>
              {fuelPrices.map((row) => (
                <Tr
                  key={`${row.date}-${row.type}`}
                  _last={{
                    '& td': {
                      borderBottom: 'none !important',
                    },
                  }}
                  border="unset"
                >
                  <Td verticalAlign="center" p={paddingTd}>
                    <Text variant="text" color={textColor}>
                      {`${row.type} - ${row.name}`}
                    </Text>
                  </Td>
                  <Td verticalAlign="center" p={paddingTd}>
                    <Text variant="text" color={'#E1E1E1'}>
                      {row.avgPrice}
                    </Text>
                  </Td>

                  <Td verticalAlign="center" p={paddingTd}>
                    <Text variant="text" color={'#E1E1E1'}>
                      {row.minPrice}
                    </Text>
                  </Td>

                  <Td verticalAlign="center" p={paddingTd}>
                    <Text variant="text" color={'#E1E1E1'}>
                      {row.maxPrice}
                    </Text>
                  </Td>

                  <Td verticalAlign="center" p={paddingTd}>
                    <Text variant="text" color={'#E1E1E1'}>
                      {row.stations}
                    </Text>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Card>
      ) : (
        <NotFound text="Not Found" />
      )}
    </>
  );
};

export default FuelPrices;
